import React, { useContext } from 'react';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import { ButtonIcon } from '@prisjakt/ui/button';
import { StoreLink, LinkDesktop, LinkMobile, LinkText } from './styles';
import { usePriceRowContext } from '../../../price-row-context';

export const GoToStoreButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { t } = useContext(AppContext);
  const { isOurChoice, position } = usePriceRowContext();
  const useSmallButton = isOurChoice && position === 'productHeader';

  return (
    <StoreLink data-test="GoToStoreButton">
      <LinkDesktop
        ariaLabel={t('product', 'store.link')}
        tabIndex={-1}
        $useSmallButton={useSmallButton}
      >
        <LinkText $isOurChoice={useSmallButton}>
          {t('product', 'store.link')}
        </LinkText>
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </LinkDesktop>

      <LinkMobile $useSmallButton={useSmallButton}>
        <IconChevronRight color="maybeBlue500" size={24} />
      </LinkMobile>
    </StoreLink>
  );
};
